import React, { useState, useEffect } from 'react'
import { AXIOS, saveSession } from '../api';
import { useDispatch } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { ToastContainer, toast } from 'react-toastify'
import _ from 'lodash'
import { signInformation, loginUser } from "../redux/actions"

const Login = () => {

    const dispatch = useDispatch()
    const location = useLocation()
    let status = new URLSearchParams(location.search).get("authenticated")

    const [error, setError] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const { handleSubmit, register, errors } = useForm()
    const history = useHistory()

    useEffect(() => {
        if (status === 'false') toast(<Toasky body="Vous devez être identifié pour accéder à cette page." />)
    }, [status])

    const onSubmit = async values => {

        try {
            // THE BACKEND CHECKS THE CREDENTIALS WITH HEITZ AND BANS THE IP FOR 10 MIN AFTER 3 FAILURES
            const { data } = await AXIOS.post(`/api/v1/auth/login`, values)
            saveSession({ token: data.token, user: data.user })
            dispatch(signInformation({ token: data.token }))
            dispatch(loginUser(data.user))
            history.push('/activites')
        } catch (error) {
            const { status, data } = error.response || {}
            if (status === 429) {
                setErrorMessage(data?.message || 'Trop de tentatives échouées. Réessayez dans 10 minutes.')
            } else if (status === 401) {
                const left = data?.attemptsLeft
                setErrorMessage(`${data?.message || 'Email ou mot de passe invalide.'}${left ? ` Il vous reste ${left} tentative(s) avant un blocage de 10 minutes.` : ''}`)
            } else {
                setErrorMessage('Le serveur est injoignable. Veuillez réessayer plus tard.')
            }
            setError(true)
        }



        // _.isEqual(values, adminAccount) ? history.push('/activites') : setError(true)
    }

    const Toasky = ({ body }) => {
        return (
            <div className="toasky">
                <div className="toasky__title">Attention :</div>
                <div className="toasky__body">{body}</div>
            </div>
        );
    }

    return (
        <div className="login">
            <div className="login__box">
                <img className="login__logo" src="/img/logo.png" alt='logo' />
                <form onSubmit={handleSubmit(onSubmit)} className="login__form">
                    <div className="login__inputWrapper">
                        <label htmlFor="email" className="form__label">Adresse email</label>
                        <input name="email" type="text" ref={register({ required: 'Email required', pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: "Invalid email address" } })} className="form__input" />
                        {errors.email && <label className="login__error" style={{ marginTop: '.5rem' }}>{errors.email.message}</label>}
                    </div>
                    <div className="login__inputWrapper">
                        <div className="login__labelWrapper">
                            <label htmlFor="password" className="form__label">mot de passe</label>
                        </div>
                        <input name="password" type="password" ref={register({ required: 'Password required' })} className="form__input" />
                        {errors.password && <label className="login__error" style={{ marginTop: '.5rem' }}>{errors.password.message}</label>}
                    </div>
                    <button type="submit" className="login__button">Connexion</button>
                    {error && <label className="login__error" style={{ textAlign: 'center' }}>{errorMessage}</label>}
                </form>
            </div>
            <ToastContainer className='toasky__wrapper' position="bottom-right" autoClose={3500} />
        </div>
    );
}

export default Login